/**
 * AI Input Provider — virtual key state for AI-controlled players.
 * Same interface as NetworkInput: setKey/getKey/clear.
 * Game logic sees the same InputProvider regardless of human/AI/network.
 */

import type { InputProvider } from '../input';

export class AIInput implements InputProvider {
  private keys = new Map<string, boolean>();

  setKey(key: string, pressed: boolean): void {
    this.keys.set(key, pressed);
  }

  getKey(key: string): boolean {
    return this.keys.get(key) ?? false;
  }

  clear(): void {
    this.keys.clear();
  }
}
